

























































import Vue from "vue";

import storeHelper from "@/store/store-helper";
import { DocumentAnchor, DocumentInfo, DocumentTypePrimitive } from "@infoland/iprova-api";
import { Comment } from "@/documentComments";
import { AnchorType } from "@/enums";
import { PendingCommentEdit } from "@/types/document/pendingDocumentComments";
export default Vue.extend({
    name: "EditCommentCard",
    props: {
        commentSubjectSelections: { type: Array as () => DocumentAnchor[] },
        comment: Object as () => Comment,
        isReviewDocument: Boolean
    },
    components: {},
    data: function () {
        return {
            commentText: this.comment ? this.comment.text : "",
            commentSubjectCurrentSelection: null as DocumentAnchor,
            commentSubjectText: this.comment ? this.comment.anchor_text : ""
        };
    },
    created(): void {
        //add watchers only when we are reviewing
        if (this.isReviewDocument) {
            this.$watch("commentSubjectText", newValue => {
                storeHelper.pendingDocumentCommentStore.addUpdateCommentEdit(this.pendingCommentEdit);
            });

            this.$watch("commentSubjectCurrentSelection", newValue => {
                storeHelper.pendingDocumentCommentStore.addUpdateCommentEdit(this.pendingCommentEdit);
            });

            this.$watch("commentText", newValue => {
                storeHelper.pendingDocumentCommentStore.addUpdateCommentEdit(this.pendingCommentEdit);
            });
        }
    },
    computed: {
        pendingCommentEdit(): PendingCommentEdit {
            const specificAnchor: boolean = this.isInteractiveOrStructuredDocument && this.commentSubjectCurrentSelection !== null;

            return {
                document: this.comment.document,
                commentID: this.comment.comment_id,
                isValid: this.validateForm(),
                commentText: this.commentText,
                anchor_id: specificAnchor ? this.commentSubjectCurrentSelection.id : null,
                anchor_text: specificAnchor ? this.commentSubjectCurrentSelection.text : this.commentSubjectText,
                anchor_type: specificAnchor ? this.commentSubjectCurrentSelection.type : AnchorType.document
            };
        },
        requiredRules() {
            return [v => !!v || this.$t("general.validation.isRequired")];
        },
        documentInfo(): DocumentInfo {
            return storeHelper.documentStore.documentInfo;
        },
        documentId(): string {
            return this.documentInfo && this.documentInfo.document_id;
        },
        isInteractiveOrStructuredDocument(): boolean {
            if (!this.documentInfo) {
                return false;
            }

            return [DocumentTypePrimitive.interactive, DocumentTypePrimitive.structured_document].indexOf(this.documentInfo.type) !== -1;
        }
    },
    methods: {
        validateForm() {
            return (this.$refs.editCommentForm as Vue & { validate: () => boolean }).validate();
        },
        async editCommentAsync(): Promise<void> {
            if (this.validateForm()) {
                if (!this.commentText.trim() || this.commentText.length > 500)
                    //Return if comment is empty or longer then the max length
                    return;

                //Set subject info
                let anchorId: string;
                let anchorType: AnchorType;
                let anchorText: string;

                if (this.isInteractiveOrStructuredDocument && this.commentSubjectCurrentSelection) {
                    anchorId = this.commentSubjectCurrentSelection.id;
                    anchorText = this.commentSubjectCurrentSelection.text;
                    anchorType = this.commentSubjectCurrentSelection.type;
                } else {
                    anchorId = null;
                    anchorText = this.commentSubjectText;
                    anchorType = AnchorType.document;
                }

                const result = await storeHelper.documentStore.editCommentAsync(
                    this.documentId,
                    this.documentInfo.version,
                    this.comment.comment_id,
                    this.commentText,
                    anchorId,
                    anchorText,
                    anchorType
                );

                if (result.success) {
                    if (this.isReviewDocument) {
                        storeHelper.pendingDocumentCommentStore.removeCommentEdit(this.comment.comment_id);
                    }
                    this.$emit("toggle-edit-comment");
                } else {
                    storeHelper.siteStore.setSnackBarMessage(this.$t("general.messages.error"), true);
                }
            }
        },
        cancelEdit(): void {
            if (this.isReviewDocument) {
                storeHelper.pendingDocumentCommentStore.removeCommentEdit(this.comment.comment_id);
            }
            this.$emit("toggle-edit-comment");
        }
    }
});
